import React, { useState, useEffect } from 'react';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertProps } from '@mui/material/Alert';

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

interface IProps {
  autoHideDuration?: number;
  open: boolean;
  message: string;
  severity: 'success' | 'error';
  onClose?: () => void;
}

export default function CustomizedSnackbars(props: IProps) {
  const { open, message, severity, onClose, autoHideDuration } = props;

  const [stateOpen, setStateOpen] = useState(open);

  useEffect(() => {
    setStateOpen(open);
  }, [open]);

  const handleClose = () => {
    if (onClose) {
      onClose();
    } else {
      setStateOpen(false);
    }
  };

  return (
    <Stack spacing={2} sx={{ width: '100%' }}>
      <Snackbar
        autoHideDuration={autoHideDuration || null}
        open={stateOpen}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: '100%' }}>
          {message}
        </Alert>
      </Snackbar>
    </Stack>
  );
}
